const Extracts = () => {
  return <div>My Extracts</div>;
};

export default Extracts;
